<template>
  <div>
    <v-row
      v-for="(input, index) in computedInputs"
      :key="index"
    >
      <v-col cols="11">
        <v-text-field
          v-model="input.value"
          solo
          hide-details="true"
          @change="changeRepeater"
        />
      </v-col>
      <v-col cols="1">
        <v-btn
          class="mx-2 remove-input"
          fab
          small
          color="btn btn-danger"
          @click="removeInput(index)"
        >
          <i class="fa fa-minus" />
        </v-btn>
      </v-col>
    </v-row>

    <v-btn
      rounded
      class="mt-3"
      @click="addInput"
    >
      +
    </v-btn>

  </div>
</template>
<script>
import RawDisplayer from "../../components/RawDisplayer";

export default {
  components: {RawDisplayer},
  props: ['stringValues', 'inputsToAdd'],
  data() {
    return {
      inputs: []
    }
  },
  methods: {
    addInput() {
      this.inputs.push({})
    },
    changeRepeater() {
      this.$emit('changeRepeater', this.inputs)
    },
    removeInput(index) {
      this.inputs.splice(index, 1);
      this.changeRepeater()
    },
  }
}
</script>
<style scoped>
  .remove-input{
    position: relative;
    top: 13px;
  }
</style>
